import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/attendance/monthly-report/")({
  head: () => ({
    meta: [{ title: "考勤月报 · imiker CRM" }],
  })
});
